import React from 'react';
import Pagination from '../../../components/base/Pagination/Pagination';
import {
  dateOrDateTimeFormatter,
} from '../../../utils/formatters';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { Button, Icons } from '../../../components/base/BootstrapComponents';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';

const STATUS_LABELS = {
  IN_PROGRESS: 'В процессе',
  READY: 'Готов',
  FAILED: 'Ошибка',
};

const STATUS_CLASS_MAP = {
  IN_PROGRESS: 'in-progress',
  READY: 'ready',
  FAILED: 'failed',
};

const statusFormatter = status => {
  const label = STATUS_LABELS[status] || status;
  const className = STATUS_CLASS_MAP[status] || 'unknown';

  return (
    <span className={`report-status status-${className}`}>
      {label}
    </span>
  );
};

export default function ReportsGrid(props) {
  const defaultColumns = [
    {
      dataField: 'id',
      text: 'ID отчета',
      disableSort: true,
      dataClassName: 'align-middle',
      headerClassName: 'id-column',
    },
    {
      dataField: 'report_name',
      text: 'Наименование отчета',
      disableSort: true,
      dataClassName: 'align-middle',
      headerClassName: 'exporter-label-column',
    },
    {
      dataField: 'status',
      text: 'Статус',
      disableSort: true,
      formatter: statusFormatter,
      dataClassName: 'align-middle',
      headerClassName: 'status-column',
    },
    {
      dataField: 'created_at',
      text: 'Дата создания',
      disableSort: true,
      formatter: item => dateOrDateTimeFormatter(item),
      dataClassName: 'align-middle',
      headerClassName: 'date-time-column',
    },
  ];

  const {
    data,
    loadData,
    onClickByRow,
    reportsListMeta,
    columns = defaultColumns,
    handleDownloadDocument = () => {},
  } = props;

  const moreFormatter = (_, item) => {
    const isReady = item?.status === 'READY';

    return (
      <TooltipWithPortal
        content={<Icons customIcon icon="dot" className="more-vert" />}
        classNamePortal="more-actions"
        tooltipContent={(
          <div className="more-wrapper">
            <Button variant="link" className="w-100 more-button delete" disabled={!isReady} onClick={() => handleDownloadDocument(item)}>
              Скачать отчёт
            </Button>
          </div>
      )}
        classNameWrapper="more-tooltip-wrapper"
        className="more-tooltip"
      />
    );
  };

  return (
    <div className="reports-table g-0">
      <div className="frame">
        <div className="sticky-table-wrapper custom-scroll-theme">
          <CustomizedGrid className="reports-grid-main" data={data} columns={columns} name="report-list" onClickByRow={onClickByRow} settingsFormatter={moreFormatter} />
        </div>
      </div>
      <Pagination meta={reportsListMeta} list={data} handleChangeMeta={loadData} />
    </div>
  );
}
